import { efFetch, isReadyLang } from '@/utils';
import { getCountryRegion } from '@/utils/countryRegion';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
const readyLangsFullSite = JSON.parse(process.env.NEXT_PUBLIC_READY_LANG_FULL_SITE || '[]');
export default function GoToIpForThePage() {
    const router = useRouter();
    const { locale = 'us', pathname } = router;
    // 个别页面跟据ip执行跳转对应站点
    const handelLocalePath = () => {
        if (typeof window === 'undefined') {
            return null;
        }
        const isEn = locale === 'en';
        const _locale = isEn ? 'us' : locale;
        const windowPath = window.location.pathname;
        if (pathname === '/' && isEn) {
            // 多语言按需加载，URL 中如有语言切换需重新初始化整个页面，不使用 router 路由
            window.location.href = '/us';
            return;
        }

        if (windowPath === '/404') {
            router.replace(`/${_locale}/404`);
            return;
        }

        // 全局的下页页跳转
        // const downloadUrlReg = /^\/support\/download\/./;
        // const videoUrlReg = /^\/support\/videos/;
        const downloadUrl = '/support/download';
        const videoUrl = '/support/videos';
        const flag1 =
            (windowPath?.indexOf(downloadUrl) > -1 || windowPath?.indexOf(videoUrl) > -1) &&
            windowPath?.indexOf(`/${locale}${downloadUrl}`) === -1 &&
            windowPath?.indexOf(`/${locale}${videoUrl}`) === -1;
        if (flag1) {
            const apiUrl = getCountryRegion(locale) === 'eu' ? process.env.NEXT_PUBLIC_LOGIN_HOST_EU : process.env.NEXT_PUBLIC_LOGIN_HOST;
            const GEO_IP_API = `${apiUrl}/website/address/finGeoByIp`;
            const COUNTRY_API = `${apiUrl}/general/location-api/countriesGroupByKey`;
            efFetch(GEO_IP_API)
                .then(async (res) => {
                    // console.log(JSON.stringify(res));
                    if (res?.code !== '0') {
                        window.location.href = `/us${windowPath}`;
                        return;
                    }
                    const macIp = res.data || { countryCode: 'US' };
                    // TODO: 特殊站点做如下处理，例如：United Kingdom的CountryCode为GB, 需要处理为uk
                    const COUNTRY_CODE_MAP = {
                        ...readyLangsFullSite.reduce((acc, current) => ({ ...acc, [current]: current }), {}),
                        gb: 'uk',
                        ru: 'cis',
                        sa: 'sa',
                    };
                    let countryCode = macIp?.countryCode?.toLowerCase();
                    if (COUNTRY_CODE_MAP[countryCode]) {
                        countryCode = COUNTRY_CODE_MAP[countryCode];
                    } else {
                        // 获取国家列表及匹配对应CountryCode的数据中心地址(eu/us)
                        let countryListData = [];
                        try {
                            const { data = [] } = await efFetch(COUNTRY_API);

                            // console.log(JSON.stringify(data));
                            countryListData = data;
                        } catch (err) {}
                        countryListData = countryListData.reduce((acc, current) => [...acc, ...current.countryResponses], []);
                        const { dataCenterCode = 'us' } = countryListData.find((v) => v.countryCode === countryCode.toUpperCase());
                        // TODO: 后端预留其余多站点，但现版本仅考虑us和eu
                        countryCode = dataCenterCode === 'us' ? 'us' : 'eu';
                    }
                    const ipLocale = typeof countryCode === 'string' ? countryCode : 'us';
                    if (!isReadyLang(ipLocale) || ipLocale === 'us') {
                        window.location.href = `/us${windowPath}`;
                        return;
                    }
                    window.location.href = `/${ipLocale}${windowPath}`;
                })
                .catch(() => {
                    window.location.href = `/us${windowPath}`;
                });
            return;
        }
    };
    useEffect(() => {
        handelLocalePath();
    }, []);
    return null;
}
